import { FC } from 'react';
import { Tabs as MuiTabs, TabsProps as MuiTabsProps } from '@mui/material';

interface TabsProps extends MuiTabsProps{}

const Tabs: FC<TabsProps> = ({...props}) => (
  <MuiTabs sx={{
    
  }} {...props} TabIndicatorProps={{
    style: {
      background: "linear-gradient(to right, #931216, #E20B23, #FF8230)",
      color: "#000"
    }
  }}/>
);

export default Tabs;
